export class MRR {
	public total: number
	public totalOwn: number
	public totalBonus: number
	public totalPlayers: number
	public totalPlayersBonus: number
	public totalBoxes: number
	public totalBoxesBonus: number
	public qPlayers: number
	public qPlayersOwn: number
	public qPlayersBonus: number
	public qBoxes: number
	public qBoxesOwn: number
	public qBoxesBonus: number
	public qLicenses: number
	public qLicensesOwn: number
	public qLicensesBonus: number
	public currency: string
	public lastMRR: number | null
	public segmentation: string

	constructor(data: {
		total: number
		totalOwn: number
		totalBonus: number
		totalPlayers: number
		totalPlayersBonus: number
		totalBoxes: number
		totalBoxesBonus: number
		qPlayers: number
		qPlayersOwn: number
		qPlayersBonus: number
		qBoxes: number
		qBoxesOwn: number
		qBoxesBonus: number
		qLicenses: number
		qLicensesOwn: number
		qLicensesBonus: number
		currency: string
		lastMRR: number | null
		segmentation: string
	}) {
		this.total = data.total
		this.totalOwn = data.totalOwn
		this.totalBonus = data.totalBonus
		this.totalPlayers = data.totalPlayers
		this.totalPlayersBonus = data.totalPlayersBonus
		this.totalBoxes = data.totalBoxes
		this.totalBoxesBonus = data.totalBoxesBonus
		this.qPlayers = data.qPlayers
		this.qPlayersOwn = data.qPlayersOwn
		this.qPlayersBonus = data.qPlayersBonus
		this.qBoxes = data.qBoxes
		this.qBoxesOwn = data.qBoxesOwn
		this.qBoxesBonus = data.qBoxesBonus
		this.qLicenses = data.qLicenses
		this.qLicensesOwn = data.qLicensesOwn
		this.qLicensesBonus = data.qLicensesBonus
		this.currency = data.currency
		this.lastMRR = data.lastMRR
		this.segmentation = data.segmentation
	}

	static create(data: Partial<MRR>): MRR {
		const defaultData: MRR = {
			total: 0,
			totalOwn: 0,
			totalBonus: 0,
			totalPlayers: 0,
			totalPlayersBonus: 0,
			totalBoxes: 0,
			totalBoxesBonus: 0,
			qPlayers: 0,
			qPlayersOwn: 0,
			qPlayersBonus: 0,
			qBoxes: 0,
			qBoxesOwn: 0,
			qBoxesBonus: 0,
			qLicenses: 0,
			qLicensesOwn: 0,
			qLicensesBonus: 0,
			currency: '',
			lastMRR: null,
			segmentation: '',
		}

		return new MRR({ ...defaultData, ...data })
	}
}
